import { Component } from '@angular/core';

@Component({
  selector: 'sonder-form-body',
  styleUrls: ['./form-body.component.scss'],
  template: `
        <div class="sonder-form-body">
            <ng-content></ng-content>
        </div>
    `,
  standalone: false
})
export class FormBodyComponent {
}
